import React from "react";

const ButtonCallToAction = () => {
    return (
        <div className="button">
            <a href="#formulaire">
                <button>
                    OBTENEZ VOTRE DEVIS GRATUIT EN REMPLISSANT CE FORMULAIRE
                </button>
            </a>
        </div>
    );
};

export default ButtonCallToAction;
